import styled from 'styled-components';
import {dFlex, alignCenter, justifyBetween, justifyEnd} from '../../../../../../../globalVariables/GlobalFlex';
import {getToken, getPrimitive, getSpacing, getFontSize, getFontWeight} from '@tickchak/react-share/app';

export const toggleHeader = styled.div<{$isActive?: boolean}>`
    ${dFlex};
    ${justifyBetween};
    ${alignCenter};
    width: 100%;
    padding: ${getSpacing('spaceMd')};
    background: ${p => p.$isActive ? 'transparent' : getPrimitive('grays.gray100')};
    border-radius: ${getSpacing('spaceMd')};
    gap: ${getSpacing('spaceSm')};
    transition: background 300ms ease, border-radius 300ms ease;
`;

export const toggleLabel = styled.span`
    font-size: ${getFontSize('caption')};
    color: ${getToken('color.text.default')};
    font-weight: ${getFontWeight('regular')};
`;

export const toggleEndSide = styled.div`
    ${dFlex};
    ${alignCenter};
    gap: ${getSpacing('spaceSm')};
`;

